import React from 'react'
import PaymentMethodTypeBankAccount from './PaymentMethodTypeBankAccount'
import PaymentMethodTypeInvoice from './PaymentMethodTypeInvoice'
import PaymentMethodTypePayPal from './PaymentMethodTypePayPal'
import PaymentMethodTypeCard from './PaymentMethodTypeCard'
import PaymentMethodTypeNoPay from './PaymentMethodTypeNoPay'
import PaymentMethodTypeGiftCard from './PaymentMethodTypeGiftCard'
import * as T from './PaymentMethodDisplay.types'
import { PaymentInstrument } from '@/pages/checkout/partials/ConfirmationOrder.types'

const PaymentMethodTypeDisplay = ({
  paymentInstrument,
  extendedDetails,
  className
}: T.PaymentMethodTypeDisplayProps) => {
  switch (paymentInstrument.paymentMethodId) {
    case 'UNZER_CARDS':
      return (
        <PaymentMethodTypeCard
          key={`payment_method_${paymentInstrument.paymentMethodId}`}
          className={className}
          paymentInstrument={
            paymentInstrument as T.IPaymentInstrumentCreditCard
          }
        />
      )
      break
    case 'UNZER_PAYPAL':
      return (
        <PaymentMethodTypePayPal
          key={`payment_method_${paymentInstrument.paymentMethodId}`}
          className={className}
          extendedDetails={extendedDetails}
          paymentInstrument={paymentInstrument as T.IPaymentInstrumentPayPal}
        />
      )
      break
    case 'UNZER_DIRECT_DEBIT_SECURED':
      return (
        <PaymentMethodTypeBankAccount
          key={`payment_method_${paymentInstrument.paymentMethodId}`}
          className={className}
          paymentInstrument={
            paymentInstrument as T.IPaymentInstrumentBankAccount
          }
        />
      )
      break
    case 'UNZER_INVOICE':
      return (
        <PaymentMethodTypeInvoice
          key={`payment_method_${paymentInstrument.paymentMethodId}`}
          className={className}
          extendedDetails={extendedDetails}
          paymentInstrument={paymentInstrument as T.IPaymentInstrumentInvoice}
        />
      )
      break
    case 'UNZER_NO_PAY':
      return (
        <PaymentMethodTypeNoPay
          key={`payment_method_${paymentInstrument.paymentMethodId}`}
        />
      )
      break
    case 'GIFT_CERTIFICATE':
      return (
        <PaymentMethodTypeGiftCard
          key={`payment_method_${paymentInstrument.paymentMethodId}`}
          paymentInstrument={paymentInstrument as PaymentInstrument}
        />
      )
      break
    default:
      return <></>
  }
}

const PaymentMethodDisplay = ({
  className,
  paymentInstruments,
  extendedDetails = true
}: T.PaymentMethodDisplayProps) => (
  <div className='flex flex-col-reverse space-y-2 space-y-reverse'>
    {paymentInstruments?.map((paymentInstrument) => (
      <PaymentMethodTypeDisplay
        key={paymentInstrument?.paymentInstrumentId}
        className={className}
        paymentInstrument={paymentInstrument}
        extendedDetails={extendedDetails}
      />
    ))}
  </div>
)

export default PaymentMethodDisplay
